import React, { useState } from 'react'; 
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import DateTimePickerBR from '../../../components/DatePicker/datepickerbr';
import 'react-datepicker/dist/react-datepicker.css';
registerLocale('pt-BR', ptBR);

export default function PainelFiltros({ filtros, onChange, equipamentos, compartimentos, fluidos, nas, anos }) {
  const [erroData, setErroData] = useState('');

  // Array de meses e anos para os selects
  const meses = [
    { valor: '01', rótulo: 'Janeiro' },
    { valor: '02', rótulo: 'Fevereiro' },
    { valor: '03', rótulo: 'Março' },
    { valor: '04', rótulo: 'Abril' },
    { valor: '05', rótulo: 'Maio' },
    { valor: '06', rótulo: 'Junho' },
    { valor: '07', rótulo: 'Julho' },
    { valor: '08', rótulo: 'Agosto' },
    { valor: '09', rótulo: 'Setembro' },
    { valor: '10', rótulo: 'Outubro' },
    { valor: '11', rótulo: 'Novembro' },
    { valor: '12', rótulo: 'Dezembro' }
  ];

  // const anos = [2022, 2023, 2024, 2025, 2026, 2027]; // Exemplo

  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  const onFilterChange = (tipo, valor) =>{
    onChange(tipo, valor);
  }
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="combo-container-conteiner">
        <div className="combo-container">
          <span>
            {/* Equipamento */}
            <label className="combo-label">Equipamento:</label>
            <select name="equipamentoId" className="combo-select" value={filtros.equipamentoId || ''}  onChange={handleChange} >
              <option key='' value=''>Todos</option>
              {equipamentos && equipamentos.map((eq) => (
                <option key={eq.cod_equipamento} value={eq.cod_equipamento}>
                  {eq.tag_equipamento} - {eq.mod_equipamento}
                </option>
              ))}
            </select>

            {/* Compartimento */}
            <label className="combo-label">  Compartimento:</label>
            <select name="compartimentoId" className="combo-select" value={filtros.compartimentoId || ''}  onChange={handleChange} >
              <option key='' value=''>Todos</option>
              {compartimentos && compartimentos.map((comp) => (
                <option key={comp.cod_compartimento} value={comp.cod_compartimento}>
                  {comp.tip_compartimento}
                </option>
              ))}
            </select>

            {/* Fluido */}
            <label className="combo-label">  Fluido:</label>
            <select name="fluido" className="combo-select" value={filtros.fluido || ''}  onChange={handleChange} >
              <option value="">Todos</option>
              {fluidos && fluidos.map((flu) => (
                <option key={flu.nom_fluido} value={flu.nom_fluido}>
                  {flu.nom_fluido}
                </option>
              ))}
            </select>
          </span>
        </div>
      </div>

      <div className="combo-container-conteiner">
        <div className="combo-container">
          <span>
            {/* NAS */}
            <label className="combo-label">NAS:</label>
            <select name="nas" value={filtros.nas || ''} onChange={handleChange} className="combo-select" >
              <option value="">Todos</option>
              {nas && nas.map((n) => (
                <option key={n.nas} value={n.nas}>
                  {n.nas}
                </option>
              ))}
            </select>

            {/* Ano */}
            <label className="combo-label">  Ano:</label>
            <select name="ano" className="combo-select" value={filtros.ano || ''}  onChange={handleChange} >
              <option value="">Todos</option>
              {anos && anos.map((a) => (
                <option key={a.ano} value={a.ano}>
                  {a.ano}
                </option>
              ))}
            </select>

            {/* Mês */}
            <label className="combo-label">  Mês:</label>
            <select name="mes" value={filtros.mes || ''} onChange={handleChange} className="combo-select"
            >
              <option value="">Todos</option>
              {meses.map(m => <option key={m.valor} value={m.valor}>{m.rótulo}</option>)}
            </select>
          </span>
        </div>
      </div>

      <div className="combo-container-conteiner">
        <div className="combo-container">
          <span>
            <div className="flex flex items-center gap-4 p-4">
              <label className="combo-label">Período:</label>
              <div>
                <DatePicker
                  selected={filtros.inicio}
                  onChange={date => onFilterChange('inicio', date)}
                  dateFormat="dd/MM/yyyy"
                  locale="pt-BR"
                  placeholderText="Selecione"
                  className="w-full p-2 border border-gray-300 rounded-md"
                  isClearable
                />
              </div>
          
              <div>
                <DatePicker
                  selected={filtros.fim}
                  onChange={date => onFilterChange('fim', date)}
                  dateFormat="dd/MM/yyyy"
                  locale="pt-BR"
                  placeholderText="Selecione"
                  className="w-full p-2 border border-gray-300 rounded-md"
                  isClearable
                />
              </div>
              {erroData && (
                <div className="w-full text-red-600 text-sm mt-2">
                  {erroData}
                </div>
              )}
            </div>
          </span>
        </div>
      </div>

    </div>  
  );
}
